<template>
  <div style="position: relative">
    <button :title="$t('buttons.manageSpaces')" :aria-label="$t('buttons.manageSpaces')" class="action" @click="show" id="manage-spaces" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1.5em" height="1.5em"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.208a2.5 2.5 0 1 1 2 0V16h-2v-3.208z" fill="rgba(255,255,255,1)"/></svg>
      <span v-if="!isMobile">{{ $t('buttons.manageSpaces') }}</span>
      <span v-else>{{ $t('buttons.spaces') }}</span>
    </button>
    <nav id="menu-private-spaces" :style="menuStyle">
      <div style="display: block">
        <button :title="$t('buttons.openPrivateSpace')" :aria-label="$t('buttons.openPrivateSpace')" class="action" @click="showOpenPrivateSpace" id="manage-spaces">
          <eye-icon size="1.5x" class="custom-class"></eye-icon>
          <span>{{ $t('buttons.openPrivateSpace') }}</span>
        </button>
        <button v-if="this.permissions === 0 && !isMaxStorage" :title="$t('buttons.createPrivateSpace')" :aria-label="$t('buttons.createPrivateSpace')" class="action" @click="showCreatePrivateSpace" id="manage-spaces">
          <plus-icon size="1.5x" class="custom-class"></plus-icon>
          <span>{{ $t('buttons.createPrivateSpace') }}</span>
        </button>
        <button v-if="isSecret" :title="$t('buttons.closePrivateSpace')" :aria-label="$t('buttons.closePrivateSpace')" class="action" @click="closePrivateSpace" id="manage-spaces">
          <eye-off-icon size="1.5x" class="custom-class"></eye-off-icon>
          <span>{{ $t('buttons.closePrivateSpace') }}</span>
        </button>
        <button v-if="isSecret && this.permissions === 0" :title="$t('buttons.modifyPrivateSpace')" :aria-label="$t('buttons.modifyPrivateSpace')" class="action" @click="modifyPrivateSpace" id="manage-spaces">
          <edit-3-icon size="1.5x" class="custom-class"></edit-3-icon>
          <span>{{ $t('buttons.modifyPrivateSpace') }}</span>
        </button>
        
        <button :title="$t('buttons.closeAllSpaces')" :aria-label="$t('buttons.closeAllSpaces')" class="action" @click="closeAllSpaces" id="manage-spaces">
          <plus-square-icon size="1.5x" class="custom-class"></plus-square-icon>
          <span>{{ $t('buttons.closeAllSpaces') }}</span>
        </button>
        <button v-if="isSecret" :title="$t('buttons.downloadCredentials')" :aria-label="$t('buttons.downloadCredentials')" class="action" @click="downloadCredentials" id="manage-spaces">
          <download-icon size="1.5x" class="custom-class"></download-icon>
          <span>{{ $t('buttons.downloadCredentials') }}</span>
        </button>
        <div ref="recoveryKeyQr" style="display: none;">
          <qrcode-vue :value="recoveryKey" size="100" level="M"></qrcode-vue>
        </div>
        <div v-if="isSecret && this.permissions === 0" class="separador"></div>
        <button v-if="isSecret && this.permissions === 0" :title="$t('buttons.clearPrivateSpace')" :aria-label="$t('buttons.clearPrivateSpace')" class="action remove" @click="clearPrivateSpace" id="manage-spaces">
          <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
          <span>{{ $t('buttons.clearPrivateSpace') }}</span>
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import jsPDF from 'jspdf';
import i18n from '@/i18n';
import moment from 'moment';
import { files as ibbapi } from '@/api';
import { mapMutations, mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import { EyeIcon, PlusIcon, PlusSquareIcon, EyeOffIcon, Edit3Icon, DownloadIcon, Trash2Icon } from 'vue-feather-icons';
import { ROUTES } from '@/router';

export default {
  name: 'manage-spaces',
  data: function () {
    return {
      isShow: false,
      isButton: false,
      recoveryKey: '',
    };
  },
  components: {
    QrcodeVue,
    EyeIcon,
    PlusIcon,
    PlusSquareIcon,
    EyeOffIcon,
    Edit3Icon,
    DownloadIcon,
    Trash2Icon
  },
  computed: {
    ...mapState([
      'handleOpenSpace',
      'selected',
      'permissions',
      'isMaxStorage'
    ]),
    menuStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
    isMobile () {
      return window.innerWidth <= 768;
    },
    isSecret() {
      return this.$route.name === ROUTES.SECRET; 
    }
  },
  async mounted() {
    window.addEventListener('click', this.click);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.click);
  },
  methods: {
    ...mapMutations(['resetSelected']),
    click() {
      if (!this.isButton && this.isShow) {
        this.isShow = !this.isShow;
      }
    },
    mouseEnter() {
      this.isButton = true;
    },
    mouseLeave() {
      this.isButton = false;
    },
    show() {
      if (this.selected.length > 0) {
        this.resetSelected();
      }
      this.isShow = !this.isShow;
    },
    showOpenPrivateSpace() {
      this.$store.commit('showHover', 'open-private-space');
    },
    showCreatePrivateSpace() {
      this.$store.commit('showHover', 'create-private-space');
    },
    async closePrivateSpace() {
      try {
        await ibbapi.closeSecret(this.handleOpenSpace);
        this.$router.push({path: '/cloud'});
      } catch (e) {
        this.$showError(e);
      }
    },
    modifyPrivateSpace() {
      this.$store.commit('showHover', 'modify-private-space');
    },
    async closeAllSpaces() {
      let openSecrets;
      try {
        openSecrets = await ibbapi.getOpenSecrets();
      } catch (e) {
        this.$showError(e);
      }

      for (let secret of openSecrets) {
        try {
          await ibbapi.closeSecret(secret.handle);
        } catch (e) {
          this.$showError(e);
        }
      }

      if (this.$route.path !== '/cloud') {
        this.$router.push({path: '/cloud'});
      }
    },
    async downloadCredentials() {
      try {
        let action = await ibbapi.getUserInfo();
        let userEmail = action.userInfo.email;
        let userFirstname = action.userInfo.firstname;
        let userLastname = action.userInfo.lastname;
        let nameFolder;

        this.recoveryKey = await ibbapi.getSecretRecoveryKey(this.handleOpenSpace);

        let openSecrets = await ibbapi.getOpenSecrets();
        for (let secret of openSecrets) {
          if (secret.handle === this.handleOpenSpace) {
            nameFolder = secret.name;
          }
        }

        await this.$nextTick();

        let offset = 50;
        let doc = new jsPDF('p', 'pt');

        let img = new Image();
        img.src = '/img/icons/ibbFavicon_32.png';
        doc.addImage(img, 'PNG', 40, 33);

        let img2 = new Image();
        img2.src = '/img/icons/logo-2.png';
        doc.addImage(img2, 'JPEG', 390, 735, 200, 105);

        doc.text(i18n.t('recoveryPrivateSpace.documentTitle'), 80, offset);
        offset += 40;
        
        doc.setFontSize(12);
        doc.setFont(undefined, 'normal');
        let splitMessage = doc.splitTextToSize('            ' + i18n.t('recoveryPrivateSpace.documentDescription'), 500);
        doc.text(splitMessage, 40, offset);

        offset += 12 * splitMessage.length + 40;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, offset, 570, offset, 'S');
        offset += 40;

        doc.setFontSize(13);
        doc.setFont(undefined, 'normal');
        doc.text(i18n.t('recoveryPrivateSpace.documentFolderName'), 40, offset);

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(nameFolder, 180, offset);
        offset += 40;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, offset, 570, offset, 'S');
        offset += 40;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(16);
        doc.text(i18n.t('recovery.documentKeyTitle'), 300, offset, null, null, 'center');
        offset += 50;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(13);
        doc.text(this.recoveryKey, 300, offset, null, null, 'center');
        offset += 20;

        doc.addImage(this.$refs['recoveryKeyQr'].firstChild.firstChild.toDataURL('image/jpeg'), 250, offset, 100, 100);
        
        offset = 580;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentWarning'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 35;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentStartRecovery'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 35;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentImportant'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 20;

        offset += 70;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, 700, 570, 700, 'S');

        doc.setFontSize(10);
        doc.text(i18n.t('recovery.documentSaveSecurely'), 40, 725);

        doc.setFontSize(11);
        doc.setFont(undefined, 'bold');
        doc.text(i18n.t('recovery.documentGeneratedBy'), 40, 755);
        doc.setFontSize(10);
        doc.text(userFirstname + ' ' + userLastname, 40, 755 + 30);
        doc.text(userEmail, 40, 755 + 45);

        doc.setFontSize(11);
        doc.setFont(undefined, 'bold');
        doc.text(i18n.t('recovery.documentDate'), 430, 750);

        doc.setFontSize(10);
        doc.text(moment().format('DD/MM/YYYY - HH:mm'), 470, 750);

        doc.save(i18n.t('recoveryPrivateSpace.documentName') + '.pdf');
      } catch (e) {
        this.$showError(e);
      }
    },
    clearPrivateSpace() {
      this.$store.commit('showHover', 'delete-private-space');
    }
  }
};
</script>